import script from "./ServiceModal.vue?vue&type=script&setup=true&lang=js"
export * from "./ServiceModal.vue?vue&type=script&setup=true&lang=js"

import "./ServiceModal.vue?vue&type=style&index=0&id=7bade700&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7bade700"]])

export default __exports__